import { Component } from '@theme/component';

/**
 * Indéscents — sélections prêtes à l'emploi (section « Pars d'une sélection »).
 * Ne manipule pas le configurateur directement : il dispatche des événements sur document,
 * écoutés par <indescents-coffret-builder> (voir indescents-coffret-builder.js).
 */
const EVT_LOAD = 'ind:coffret:load';
const EVT_FAMILY = 'ind:coffret:family';

class IndescentsCoffretPresets extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.fallback = this.dataset.fallbackUrl || '';
    this.loads = Array.from(this.querySelectorAll('[data-load]'));
    this.chips = Array.from(this.querySelectorAll('[data-fam]'));
    this.loads.forEach((btn) => btn.addEventListener('click', () => this.load(btn)));
    this.chips.forEach((chip) => chip.addEventListener('click', () => this.family(chip)));
  }

  hasBuilder() { return !!document.querySelector('indescents-coffret-builder'); }

  load(btn) {
    const titles = (btn.dataset.titles || '').split('|').map((t) => t.trim()).filter(Boolean);
    if (!this.hasBuilder()) { if (this.fallback) window.location.href = this.fallback; return; }
    document.dispatchEvent(new CustomEvent(EVT_LOAD, { detail: { titles } }));
    if (btn.dataset.indLabel === undefined) btn.dataset.indLabel = btn.textContent;
    btn.textContent = 'Sélection chargée ✓';
    btn.classList.add('is-done');
    clearTimeout(btn._t);
    btn._t = setTimeout(() => { btn.textContent = btn.dataset.indLabel; btn.classList.remove('is-done'); }, 2500);
  }

  family(chip) {
    const fam = chip.dataset.fam;
    if (!fam) return;
    if (!this.hasBuilder()) { if (this.fallback) window.location.href = this.fallback; return; }
    document.dispatchEvent(new CustomEvent(EVT_FAMILY, { detail: { fam } }));
  }
}

if (!customElements.get('indescents-coffret-presets')) customElements.define('indescents-coffret-presets', IndescentsCoffretPresets);
